module.exports = __webpack_public_path__ + "static/media/16.d77d3964.png";